import SDUBanner from 'components/OrderConfirmation/SDUBanner/SDUBanner';

export default SDUBanner;
